import React from 'react';
import { Title } from '../components';
import { placesToGo } from '../data';
import Place from './Place';
import SectionIntro from './SectionIntro';

const Masonry = () => {
  return (
    <>
      <section className="section bg-gray-50" id="places">
        <Title title="places to go" />
        <div className="section-center ">
          {/* Places introduction */}
          <SectionIntro
            title="Explore the best places in Vietnam"
            intro=" Choose from the best holiday destinations in Vietnam. And best of
              all, it’s quarantine-free for the fully vaccinated. You are free
              to enjoy full holiday access upon arrival. Take in new sites,
              sounds, and flavors. Experiences that are truly memorable. Live
              fully in Vietnam."
          />

          {/* Places Masonry */}
          <div className="flex flex-wrap md:-m-2 -m-1">
            {/* 1st half */}
            <div className="places-container">
              {placesToGo.slice(0, 3).map((place, index) => (
                <Place
                  key={place.id}
                  place={place}
                  half={index !== placesToGo.slice(0, 3).length - 1}
                />
              ))}
            </div>

            {/* 2nd half */}
            <div className="places-container">
              {placesToGo.slice(3, placesToGo.length).map((place, index) => (
                <Place key={place.id} place={place} half={index !== 0} />
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Masonry;
